import { render, staticRenderFns } from "./Formulario.vue?vue&type=template&id=81106486"
import script from "./Formulario.vue?vue&type=script&lang=js"
export * from "./Formulario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81106486')) {
      api.createRecord('81106486', component.options)
    } else {
      api.reload('81106486', component.options)
    }
    module.hot.accept("./Formulario.vue?vue&type=template&id=81106486", function () {
      api.rerender('81106486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organizacion/Formulario.vue"
export default component.exports